var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_c('router-link',{attrs:{"to":"smooth-scroll"}},[_vm._v("vue-simple-smooth-scroll")])],1),_c('h1',[_c('router-link',{attrs:{"to":"silk-smooth-scroll"}},[_vm._v("silk-smooth-scroll")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }